import { getContent } from "./getContent/getContent.mjs";
const getDictionary = (dictionary, locale, plugins) => {
  const props = {
    dictionaryKey: dictionary.key,
    dictionaryPath: dictionary.filePath,
    keyPath: [],
    plugins
  };
  return getContent(
    dictionary.content,
    props,
    locale
  );
};
export {
  getDictionary
};
//# sourceMappingURL=getDictionary.mjs.map